import React from 'react';

import { StyledSider, StyledSiderProps } from './styles';

const Sider: React.FC<StyledSiderProps> = (props) => {
  return <StyledSider {...props} />;
};

export default Sider;
